import React, {Component} from 'react';
import styled from 'styled-components';
import uuid from 'uuid/v1';
import {mixins} from "../../mixins";

class CheckBox extends Component {

    handleCheck = (e) => {
        const type = this.props.type || 'checkbox';
        if (type === 'checkbox') {
            this.props.callback(e.target.checked);
        } else if (e.target.checked) {
            this.props.callback(e.target.value);
        }
    };

    render() {
        const id = uuid();
        return (
            <div className={this.props.className}>
                <input value={this.props.value || 1} id={id} checked={this.props.checked} onChange={(e) => {
                    this.handleCheck(e)
                }} type={this.props.type || 'checkbox'}/>
                <label htmlFor={id}>
                    {this.props.label}
                </label>
            </div>
        );
    }
}

export default styled(CheckBox)`
  input{
    opacity: 0;
    visibility: hidden;
    width: 0.1px;
    height: 0.1px;
    pointer-events: none;
    position: absolute;
    left: 0;
    top: 0;
  }
  label{
    padding-left: 34px;
    position: relative;
    cursor: pointer;
    &:before{
      ${mixins.pseudoToBlock()};
      height: 20px;
      width: 20px;
      border: 1px solid ${p => p.theme.cMicrocopyText};
      position: absolute;
      left: 0;
      top: 0.6em;
      margin-top: -10px;
      ${p => p.type === 'radio' ? 'border-radius: 50%' : ''};
    }
    &:after{
      ${mixins.pseudoToBlock()};
      height: 14px;
      width: 14px;
      background-color: ${p => p.theme.cTheme};
      position: absolute;
      left: 3px;
      top: calc(.6em + 3px);
      margin-top: -10px;
      opacity: 0;
      transform: scale(0.8);
      ${mixins.ease()};
      ${p => p.type === 'radio' ? 'border-radius: 50%' : ''};
    }
  }
  input:checked ~ label{
    &:after{
      opacity: 1;
      transform: none;
    }
  }
`;